import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SideCart from '../components/SideCart';
import TawkToLoader from '../components/TawkToLoader';

const LayoutV1 = () => (
  <>
    <Header />
    <SideCart />
    <TawkToLoader />
    <Outlet />
    <Footer />
  </>
);

export default LayoutV1;
